import {createSlice} from "@reduxjs/toolkit";

const initialSchPayReceiptsState = {
  listLoading: false,
  actionsLoading: false,
  totalCount: 0,
  entities: null,
  schPayReceiptForEdit: undefined,
  lastError: null
};
export const callTypes = {
  list: "list",
  action: "action"
};

export const schPayReceiptsSlice = createSlice({
  name: "schPayReceipts",
  initialState: initialSchPayReceiptsState,
  reducers: {
    catchError: (state, action) => {
      state.error = `${action.type}: ${action.payload.error}`;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = false;
      } else {
        state.actionsLoading = false;
      }
    },
    startCall: (state, action) => {
      state.error = null;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = true;
      } else {
        state.actionsLoading = true;
      }
    },
    // getSchPayReceiptById
    schPayReceiptFetched: (state, action) => {
      state.actionsLoading = false;
      state.schPayReceiptForEdit = action.payload.schPayReceiptForEdit;
      state.error = null;
    },
    // findSchPayReceipts
    schPayReceiptsFetched: (state, action) => {
      const { totalCount, entities } = action.payload;
      state.listLoading = false;
      state.error = null;
      state.entities = entities;
      state.totalCount = totalCount;
    },
    // createSchPayReceipt
    schPayReceiptCreated: (state, action) => {
      state.actionsLoading = false;
      state.error = null;
      state.entities.push(action.payload.schPayReceipt);
    },
    // updateSchPayReceipt
    schPayReceiptUpdated: (state, action) => {
      state.error = null;
      state.actionsLoading = false;
      state.entities = state.entities.map(entity => {
        if (entity.schPayReceiptId === action.payload.schPayReceipt.schPayReceiptId) {
          return action.payload.schPayReceipt;
        }
        return entity;
      });
    },
    // deleteSchPayReceipt
    schPayReceiptDeleted: (state, action) => {
      state.error = null;
      state.actionsLoading = false;
      state.entities = state.entities.filter(el => el.schPayReceiptId !== action.payload.schPayReceiptId);
    },
    // deleteSchPayReceipts
    schPayReceiptsDeleted: (state, action) => {
      state.error = null;
      state.actionsLoading = false;
      state.entities = state.entities.filter(
        el => !action.payload.ids.includes(el.schPayReceiptId)
      );
    },
  }
});
